import React from 'react'

// Form Validation
import { useWatch } from 'react-hook-form'

import { useDebounce } from 'hooks/useDebounce'
import { useGetSuppliersByName } from 'hooks/useMasterData'
import { HeaderFieldsStandard } from 'utils/Constants'

import AutoCompleteAsyncHeader from './AutoCompleteAsyncHeader'

const SupplierSearchName = props => {
  const { control, headerFieldsActions, appId, getValues, setValueForm, headerField } = props

  const value = useWatch({
    name: 'headerFields',
    control
  })

  const { deleteErrorHeader } = headerFieldsActions

  const supplierField = value.find(x => x.field === headerField.field)

  const supplierName = supplierField?.value

  const [filter, setFilter] = React.useState(null)
  const [debouncedValue] = useDebounce(filter, 500)

  const suppliers = useGetSuppliersByName(debouncedValue, { appId })

  React.useEffect(() => {
    setFilter(supplierName ? supplierName : null)
  }, [supplierName])

  const options = suppliers.data?.map(x => ({ label: x.supplierId, value: x.name })) ?? []

  function onChangeAutoComplete(data) {
    const summaryFields = getValues('headerFields')
    const indexVendorField = summaryFields.findIndex(
      summaryField => summaryField.field === HeaderFieldsStandard['supplier.id'].type
    )

    if (indexVendorField < 0) {
      return
    }

    if (data) {
      setValueForm(`headerFields.${indexVendorField}.value`, data.label, {
        shouldValidate: true,
        shouldDirty: true
      })
    } else {
      setValueForm(`headerFields.${indexVendorField}.value`, '', {
        shouldValidate: true,
        shouldDirty: true
      })
    }
    deleteErrorHeader({
      field: HeaderFieldsStandard['supplier.name'].type
    })
  }

  return (
    <AutoCompleteAsyncHeader
      {...props}
      filter={filter ?? ''}
      setFilter={setFilter}
      options={options}
      isLoading={suppliers.isLoading || suppliers.isFetching}
      onChangeAutoComplete={onChangeAutoComplete}
    />
  )
}

export default SupplierSearchName
